<div style="height: 100vh; display: flex; align-items:center;justify-content:center;">
    <mat-spinner></mat-spinner>
  </div>